
<template>
  <Nav-bar :has_back="true" :has_right="false" title="费率列表"></Nav-bar>
  <div class="top-margin"></div>
  <div class="container">
    <div class="title-block-list">
      <div class="block title-border">
        <span class="t-f12-c1a font-bold">计费时段</span>
      </div>
      <div class="block title-border">
        <span class="t-f12-c1a font-bold">电费单价</span>
      </div>
      <div class="block title-border">
        <span class="t-f12-c1a font-bold">服务费单价</span>
      </div>
      <div class="block title-border">
        <span class="t-f12-c1a font-bold ">总单价</span>
      </div>
    </div>
    <div class="time-list" v-for="list in state.billingRules" :key="list">
      <div class="block time-border">
        <span class="t-f12-c66">{{ list.from}} - {{ list.to}}</span>
      </div>
      <div class="block time-border">
        <span class="t-f12-c66">{{list.power_rate}}元/度 </span>
      </div>
      <div class="block time-border">
        <span class="t-f12-c66">{{list.service_rate}}元/度 </span>
      </div>
      <div class="block time-border" >
        <span class="t-f12-c66">{{parseFloat(list.power_rate)+ parseFloat(list.service_rate)}}元/度 </span>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "../../components/NavBar.vue";
import { useRouter } from "vue-router";
import { ref,reactive } from "vue";
import request from "@/api/request";
export default {
  components: {
    NavBar: NavBar,
  },
  setup() {
    const router = useRouter();
       const state = reactive({
      billingRules: [],
    });
    let id = ref("");
    id = router.currentRoute.value.params.id;
    request.getChargersDetails(id)
      .then((res) => {
        state.billingRules = res.data.billing_rules[0].rule;
      })
   
    return { ref, state, router };
  },
};
</script>

<style scoped>
.container {
  margin:  15px;
  border-radius: 5px;
}
.title-block-list {
  background: #ecf6ff;
  display: flex;
}
.block {
  flex: 1;
  margin: 0px;
  line-height: 40px;
  border-radius: 0 !important;
  text-align: center;
}
.time-list {
  display: flex;
  background: #fff;
}
.title-border {
  border-right: 1px solid #e0e0e0;
}
.time-border {
  border-right: 1px solid #e0e0e0;
  border-bottom:  1px solid #e0e0e0;
}
</style>